<template>
  <div v-if="votes">

    <component v-bind:is="get_design()" :survey="survey" :design="design" :votes="votes" :entries="entries" />

  </div>
</template>

<script>


export default{

  props: {survey: Object, design: String},

  data: function () {

      return {
        votes: false,
        entries: false,
      }
  },

  methods:{

    get_design(){
      var designs = this.$store.getters.votings;

      if(this.design)
        return designs[this.design];

      return designs.Slider;

    },

  },

  mounted(){

    if (this.$store.getters.votes == 'undefined' || !this.$store.getters.votes) { this.entries = [[], 0]; return false; }

    this.entries = [];
    this.votes = [[],0];

    this.$store.getters.votes.forEach(function (val) {
      if ((val.board * 1) == (this.survey.ID * 1)) {
        this.entries.push(val)
        this.votes[0].push([ val.name, ['hit_stars', {stars: val.average, append: true, animate: true}], val.time ])
        this.votes[1] += (val.average * 1)
      }
    }.bind(this));

    if (this.votes[1] > 0) { this.votes[1] = this.votes[1] / this.votes[0].length }


  }
}

</script>
